import React, {useCallback, useEffect, useRef, useState} from "react";
import {PlayerCard} from "components/PlayerCard";
import styled from "@emotion/styled";
import {Question} from "components/Question";
import {useDispatch, useSelector} from "react-redux";
import {
	getCurrentPlayers,
	getCurrentQuestion,
	getCurrentQuestionIndex,
	getCurrentTimerTimeLimit,
} from "modules/selectors/contest";
import {GameTimer} from "components/GameTimer";
import {eq, get} from "lodash";
import {setTimerTimeLimit} from "modules/actions";

const Wrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 17px;
	justify-content: center;
	align-items: center;
	width: 100%;
	transition: 0.5s;

	&.darken .player-card:not(.answered):before {
		transition-delay: 1s;
		background: rgb(22, 22, 22, 0.7);
	}
`;

const CardsWrapper = styled.div`
	width: 100%;
	overflow: hidden;
	max-height: 378px;
	height: 378px;
	position: relative;
`;

const CardsScroller = styled.div<{index: number}>`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
	width: 100%;
	transition: 0.5s;
	top: calc(192px * ${(props) => props.index - 1} * -1);
`;

export const PlayersField: React.FC = () => {
	const dispatch = useDispatch();
	const question = useSelector(getCurrentQuestion);
	const timeToQuestion = get(question, "timeToQuestion", 10);
	const questionIndex = useSelector(getCurrentQuestionIndex);
	const sliderRef = useRef<HTMLDivElement>(null);
	const players = useSelector(getCurrentPlayers);
	const [className, setClassName] = useState("");

	const currentTimerTimeLimit = useSelector(getCurrentTimerTimeLimit);
	const timeLimitsNotSame = !eq(timeToQuestion, currentTimerTimeLimit);
	const [timerPaused, setTimerPaused] = useState(false);

	useEffect(() => {
		if (timeLimitsNotSame) {
			// setClassName("darken");

			setTimerPaused(true);

			setTimeout(() => {
				setClassName("");

				dispatch(setTimerTimeLimit(timeToQuestion));

				setTimeout(() => {
					setTimerPaused(false);
				}, 1000);
			}, 3000);
		} else {
			setClassName("");
		}
	}, [timeLimitsNotSame, timeToQuestion, question, dispatch]);

	const isLastItem = useCallback(
		(position: number) => {
			return position === players.playersArray.length - 1;
		},
		[players]
	);

	const getClassName = useCallback(
		(position: number) => {
			return position <= players.playersArray.length - 3 ? "previous" : "";
		},
		[players]
	);

	return (
		<Wrapper className={className}>
			<Question />
			<CardsWrapper ref={sliderRef}>
				<GameTimer paused={timerPaused} />
				<CardsScroller index={questionIndex}>
					{players.playersArray.map((item, index) => (
						<PlayerCard
							key={item}
							className={getClassName(index)}
							isAnimated={isLastItem(index)}
							playerId={item}
						/>
					))}
				</CardsScroller>
			</CardsWrapper>
		</Wrapper>
	);
};
